import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useAdParameters } from '../../common/creative/hooks/useAdParameters';
import { useAdSize } from '../../common/creative/hooks/useAdSize';
import { useClickthru } from '../../common/creative/hooks/useClickthru';
import { useControls } from '../../common/creative/hooks/useControls';
import { useManualDuration } from '../../common/creative/hooks/useManualDuration';
import { useOnTime } from '../../common/creative/hooks/useOnTime';
import { Platform, usePlatform } from '../../common/creative/hooks/usePlatform';
import { useSetAdBackgroundColor } from '../../common/creative/hooks/useSetAdBackgroundColor';
import { useSetAdIsDisplay } from '../../common/creative/hooks/useSetAdIsDisplay';
import { useVPAIDPlayState } from '../../common/creative/hooks/useVPAIDPlayState';
import { teadsApi } from '../../common/teads-api';
import { PerformanceSingleImageConfig } from './config';
import { PerformanceSingleImageCreative } from './creative';

export function useSelectedVariation() {
  const [selectedVariations, setSelectedVariations] = useState({ main_image: '', cta: '', title: '' });

  useEffect(() => {
    teadsApi.getContextData((err, response) => {
      if (err) return console.error(err);
      setSelectedVariations({
        main_image: response?.['selected-variation']?.['main-image'] || '',
        cta: response?.['selected-variation']?.cta || '',
        title: response?.['selected-variation']?.title || '',
      });
    });
  }, []);
  return selectedVariations;
}

export function PerformanceSingleImage() {
  const { updateTime } = useControls();
  const adParameters = useAdParameters<PerformanceSingleImageConfig>();
  const assetRef = useRef<HTMLImageElement>(null);

  const platform = usePlatform();
  const adSize = useAdSize();

  const selectedVariation = useSelectedVariation();

  useSetAdBackgroundColor('#fff');
  useSetAdIsDisplay(true);

  const { playState } = useVPAIDPlayState();
  useManualDuration(playState.isPlaying, 15, updateTime);

  const [isCtaActive, setCtaActive] = useState(false);
  useOnTime(2, () => setCtaActive(true));

  const onClick = useClickthru(adParameters.config.destination_url);

  if (platform === Platform.Unknown) return null;

  return (
    <PerformanceSingleImageCreative
      {...{ adSize, imgRef: assetRef, onClick, isCtaActive, platform, selectedVariation }}
    />
  );
}
